import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { GraphService } from '../../General/graph/graph.service';
import { TeacherGraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/teacher-graph-exercise.component';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';
import { GraphUU } from '../../shared/interactive-graph/simple_graphs/graphUU';
import { AbstractNode } from 'graph-interactive/dist/lib/abstract/aNode';
import { AbstractEdge } from 'graph-interactive/dist/lib/abstract/aEdge';
import { GraphAlgorithm, NameVertex, GraphServiceJson, GraphRandom } from 'graph-interactive';

@Component({
  selector: 'app-t-find-simple-path',
  templateUrl: './t-find-simple-path.component.html',
  styleUrls: ['./t-find-simple-path.component.css']
})
export class TFindSimplePathComponent extends TeacherGraphExerciseComponent {
  private readonly canvasID: string = 'graph-canvas';
  private readonly selectPathID: string = 'selectPath';

  private readonly computeID: string = 'computeButton';
  private selectPath: HTMLSelectElement;
  private allPaths: [AbstractNode[], AbstractEdge[]][] = [];
  private allPathLength: number[] = [];

  private readonly selectCountID: string = 'selectCount';
  private selectCount: HTMLSelectElement;


  private previousMinPath: number = 0;


  constructor(protected topicsService: TopicService, protected activatedRoute: ActivatedRoute, graphService: GraphService) {
    super(topicsService, activatedRoute);
    this.type = 'findSimplePath';
    this.title = this.get('findSimplePath');
    this.description = this.get('descriptionFindSimplePath');
  }

  generate(){
    GraphRandom.generateGraph(this.graph, true);
  }
  
  initGraph(): InteractiveGraph {
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    const graph: GraphUU = new GraphUU(canvas);

    const computeButton = <HTMLButtonElement>document.getElementById(this.computeID);
    computeButton.addEventListener('click', this.computeSolution, false);

    const selectPath = <HTMLSelectElement>document.getElementById(this.selectPathID);
    selectPath.addEventListener('keydown', this.pathOnChange, false);
    selectPath.addEventListener('keyup', this.pathOnChange, false);
    selectPath.addEventListener('keypress', this.pathOnChange, false);
    selectPath.addEventListener('change', this.pathOnChange, false);
    selectPath.addEventListener('click', this.pathOnChange, false);

    this.selectPath = selectPath;
    this.selectCount = <HTMLSelectElement>document.getElementById(this.selectCountID);

    return graph;
  }

  computeSolution = () => {
    this.allPaths = GraphAlgorithm.allSimplePaths(this.graph.getSourceNode(),
      this.graph.getTargetNode(), this.graph.getGraph(), this.graph.getMandatoryNodes());

    this.allPathLength = [];
    for (let i = 1; i <= this.allPaths.length; i++) {
      this.allPathLength.push(i);
    }
  }

  showPath = (path: [AbstractNode[], AbstractEdge[]]) => {
    this.graph.highLightPath(path[0], path[1]);
  }

  pathOnChange = () => {
    let index = this.selectPath.selectedIndex;
    if (index >= this.allPaths.length || index < 0) {
      console.log("Invalid index");
      return;
    }
    let path = this.allPaths[index];
    this.showPath(path);
  }

  pathToString = (path: [AbstractNode[], AbstractEdge[]]): String => {
    let res: String = "";
    path[0].forEach(node => {
      if (node instanceof NameVertex) {
        res = res + node.getName() + " ";
      }
    })
    return res;
  }

  ngAfterViewInit(){
    super.ngAfterViewInit();
      if(this.importMinimumPath() != -1){
        this.previousMinPath = this.importMinimumPath(); 
      }
  }




  generateDefinition(): any {
    const definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = './assets/images/findSimplePath.png';
    definition.key = 'pathFinding%'.concat(this.type, '%' + this.id);
    if (this.examId > -1) {
      definition.key = definition.key.concat('exam%', this.examId.toString(), '%');
    }

    GraphServiceJson.exportGraph(this.graph, definition);

    this.computeSolution();
    let count = Number(this.selectCount.value);
    count = (count > this.allPaths.length) ? this.allPathLength.length : count;

    if(count == 0){
      count = this.previousMinPath; 
    }

    this.exportMinimumPath(count, definition);
    return definition;
  }
}


